import React from 'react';
import {makeStyles} from '@mui/styles';
import { Button, CardActions, CardContent, Divider, Grid, Typography } from '@mui/material';

import {About} from './components/';
import PageHeader from "../../../components/PageHeader/PageHeader";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { useSelector } from 'react-redux';
import { history } from '../../../helpers/history';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    marginTop: 0
  }
}));

const AboutSettings = () => {
  const classes = useStyles();
  const { role } = useSelector(state=> state.authentication.user);

  const authenticatedUser = useSelector(state => state.authentication.user);

  const onUploadLicenseFiles = () => {
    history.push({
      pathname: '/license/upload',
    });
  }

  return (
    <div className={classes.root}>
      <PageHeader title={"About"} subTitle={"Information about Application"}/>
      <Card  className={classes.content}>
        <CardContent>
          <Grid
            container
            spacing={4}
          >
            <Grid
              item
              xs={6}
            >
              <About
                  user = {authenticatedUser}
              />
            </Grid>
          </Grid>
          {role.toLowerCase().includes('admin') ? (
          <CardActions>
            <Button
              className={classes.button}
              variant="outlined"
              onClick={onUploadLicenseFiles}
            >
              Update License Files
            </Button>
          </CardActions>
            ) :  null
          }
        </CardContent>
      </Card>
    </div>
  );
};

export default AboutSettings;
